import { ApiEmployee } from "@/types/employees/employee.types.ts";
import { ApiFilterBase } from "@skailer-com/uikit/core";
import {
  ApiForm,
  ApiFormStats,
  ApiFormViewElement,
  ApiFormViewElementOpenAnswerSettings,
} from "@/types/forms/form-view.types.ts";
import { ApiFormResultAnswer, ApiFormScoreMark } from "@/types/forms/form.types.ts";
import { ApiApplicant } from "@/types/recruit/applicant.types.ts";
import { ApiJobShort } from "@/types/recruit/job.types.ts";

export interface ApiScoreCardSearchFilter extends ApiFilterBase {
  text: string | undefined;
}

export interface ApiScoreCardShort {
  id: number;
  title: string;
  description: string;
  emoji?: string;
}

export interface ApiScoreCardLong extends ApiScoreCardShort {
  form: ApiForm;
}

export type ApiScoreCardPayload = Omit<ApiScoreCardShort, "id">;

export enum ApiScoreCardStatus {
  invited = "invited",
  in_progress = "in_progress",
  completed = "completed",
}

export interface ApiFeedbackScoreCard {
  id: number;
  candidate_id: number;
  applicant?: (ApiApplicant & { color_palette: string[] }) | null;
  employee: ApiEmployee;
  created_by: ApiEmployee;
  scorecard: ApiScoreCardShort;
  status: ApiScoreCardStatus;
  form_stats: ApiFormStats;
  is_archived?: boolean;
  completed_at?: Date;
  job?: ApiJobShort;
}

export interface ApiCandidateFeedback extends ApiFeedbackScoreCard {
  open_answer?: ApiFormResultAnswer;
  open_question?: ApiFormViewElementOpenAnswerSettings;
  question_answer?: ApiFormResultAnswer;
  question_element?: ApiFormViewElement;
  avg_score_mark?: ApiFormScoreMark;
  max_scale_score?: number;
  avg_scale_score?: number;
}

export interface ApiCandidateFeedbacksOverview {
  archived_count?: number;
  avg_scale_score?: number;
  avg_score_mark?: ApiFormScoreMark;
  completed_count: number;
  feedbacks: ApiCandidateFeedback[];
  max_scale_score?: number;
  requested_count: number;
  score_marks: ApiFormScoreMark[];
}
